import React from 'react';
import {ShippingDashboardRow, SlimCarrierStatusCarrierAssignment} from '@shipwell/backend-core-singlerequestparam-sdk';
import {getIsLTL} from 'App/containers/Dashboard/columns';

export const CarrierCell = ({
  shipment,
  relationshipToVendor
}: {
  shipment: ShippingDashboardRow;
  relationshipToVendor?: SlimCarrierStatusCarrierAssignment;
}) => {
  //check if the vendor is the assigned carrier. if not, then we show the carrier instead of this relationship
  const isAssignedCarrier = relationshipToVendor?.is_assigned_carrier;
  return (
    <div>
      {
        //if there is a vendor at all, show it
        relationshipToVendor?.vendor ? (
          <div>
            {shipment.mode &&
            //if LTL, show the carrier assignment instead of the vendor
            getIsLTL(shipment.mode.code || '') &&
            !isAssignedCarrier ? (
              <span>
                {shipment.current_carrier && shipment.current_carrier.name}
                {!shipment.current_carrier && relationshipToVendor.vendor.name}
              </span>
            ) : (
              <span>{relationshipToVendor.vendor.name}</span>
            )}
          </div>
        ) : (
          '--'
        )
      }
    </div>
  );
};
